import React, { useState } from "react";
import Cropper from "react-easy-crop";

interface Props {
  image: any;
  onCropDone: (imageArea: any) => void;
  onCropCancel: () => void;
}

const ImageCropper: React.FC<Props> = ({ image, onCropDone, onCropCancel }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedArea, setCroppedArea] = useState(null);
  const [aspectRatio, setAspectRatio] = useState(1 / 1);

  const onCropComplete = (croppedAreaPercentage:any, croppedAreaPixels:any) => {
    setCroppedArea(croppedAreaPixels);
  };

  return (
    <div className="cropper">
      <div>
        <Cropper
          image={image}
          aspect={aspectRatio}
          crop={crop}
          zoom={zoom}
          onCropChange={setCrop}
          onZoomChange={setZoom}
          onCropComplete={onCropComplete}
          style={{
            containerStyle: {
              width: "100%",
              height: "80%",
              backgroundColor: "#fff",
            },
          }}
        />
      </div>

      <div className="action-btns">
        <button className="cancel-btn" onClick={onCropCancel}>
          Cancel
        </button>
        <button
          className="crop-btn"
          onClick={() => {
            onCropDone(croppedArea);
          }}
        >
          Crop
        </button>
      </div>
    </div>
  );
};

export default ImageCropper;
